import React, { useState } from "react";
import "./ModalPreencherCoordenadas.css"; // Crie um estilo simples

function ModalPreencherCoordenadas({ aberto, onClose }) {
  const [andamento, setAndamento] = useState([]);
  const [status, setStatus] = useState("esperando"); // esperando, carregando, finalizado, erro
  const [concluidos, setConcluidos] = useState(0);
  const [total, setTotal] = useState(null);

  const iniciar = async () => {
    setStatus("carregando");
    try {
      const res = await fetch("/admin/preencher-coordenadas-empresas", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const json = await res.json();

      if (json.sucesso) {
        setStatus("finalizado");
        setConcluidos(json.novos);
        setTotal(json.total || "?");
      } else {
        throw new Error(json.error || "Erro desconhecido");
      }
    } catch (err) {
      console.error("Erro ao preencher coordenadas:", err);
      setStatus("erro");
    }
  };

  return (
    <div className={`modal-coordenadas ${aberto ? "aberto" : ""}`}>
      <div className="conteudo-modal">
        <h3>Preenchimento de Coordenadas</h3>

        {status === "esperando" && (
          <button onClick={iniciar}>Iniciar processo</button>
        )}

        {status === "carregando" && (
          <p>🔄 Buscando coordenadas... aguarde. Verifique o console para detalhes.</p>
        )}

        {status === "finalizado" && (
          <p>✅ {concluidos} novos CEPs foram armazenados com sucesso.</p>
        )}

        {status === "erro" && (
          <p style={{ color: "red" }}>❌ Ocorreu um erro. Veja o console para detalhes.</p>
        )}

        <button onClick={onClose}>Fechar</button>
      </div>
    </div>
  );
}

export default ModalPreencherCoordenadas;
